export interface SatelliteSourceConfig {
    layerTypesPath: string;
    layerPath: string;
    bodyKey: string;
    resolution: string;
}

export const SATELLITE_SOURCE_CONFIG: Record<string, SatelliteSourceConfig> = {
    sentinel: {
        layerTypesPath: "/satellite/sentinel_layers",
        layerPath: "/farms/:farmId/parcels/:plotId/satellite/sentinel",
        bodyKey: "sentinel",
        resolution: "10x10",
    },
    planet_scope: {
        layerTypesPath: "/satellite/planet_scope_sentinel_layers",
        layerPath:
            "/farms/:farmId/parcels/:plotId/satellite/planet_scope_sentinel",
        bodyKey: "sentinel",
        resolution: "3x3",
    },
};

export const FARM_SATELLITE_OPTIONS = ["sentinel", "planet_scope"] as const;
export type FarmSatelliteOption = (typeof FARM_SATELLITE_OPTIONS)[number];
